'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

require('./css/index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDTextArea = function (_BaseComponent) {
  (0, _inherits3.default)(IDTextArea, _BaseComponent);

  function IDTextArea(props) {
    (0, _classCallCheck3.default)(this, IDTextArea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDTextArea.__proto__ || (0, _getPrototypeOf2.default)(IDTextArea)).call(this, props));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var value = event.target.value;
      _this.setValue(value);
    };

    _this.handleFocus = function (event) {
      _this.Placeholder && _this.Placeholder.hidden();
      _this.props.onFocus && _this.props.onFocus(event);
    };

    _this.handleBlur = function () {
      _this.Placeholder && _this.Placeholder.show();
      var value = _this.getValue();
      _this.props.onBlur && _this.props.onBlur(value);
    };

    _this.onClear = function () {
      _this.setValue('');
    };

    _this.state = {
      isFocus: false,
      value: props.value || props.defaultValue
    };
    _this.dataTestID = 'text-area';
    _this.inputType = 'textArea';
    return _this;
  }

  (0, _createClass3.default)(IDTextArea, [{
    key: 'setValue',
    value: function setValue(value) {
      var _this2 = this;

      this.setState({ value: value || '' }, function () {
        _this2.props.onChange && _this2.props.onChange(value);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // if (!this.props.fromIDInput) {
      //   throw new Error(`Vui lòng sử dụng <IDInput type="${this.inputType}" />`);
      // }

      var _props = this.props,
          disabled = _props.disabled,
          type = _props.type,
          minHeight = _props.minHeight,
          className = _props.className,
          style = _props.style,
          readOnly = _props.readOnly,
          spellcheck = _props.spellcheck,
          autoFocus = _props.autoFocus,
          isDisplay = _props.isDisplay;
      var value = this.state.value;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('body-wrap textarea', className, { 'input-area-disabled': disabled || readOnly }),
          style: (0, _extends3.default)({}, style, { minHeight: minHeight })
        },
        isDisplay ? _react2.default.createElement(
          'p',
          {
            readOnly: readOnly,
            className: 'textarea-input',
            ref: function ref(c) {
              _this3.ref = c;
            },
            style: {
              flex: 1,
              border: 0,
              padding: '5px 8px',
              height: '100%',
              outline: 0,
              background: 'transparent',
              minHeight: minHeight,
              marginBottom: 0,
              whiteSpace: 'pre-line'
            }
          },
          value
        ) : _react2.default.createElement('textarea', {
          readOnly: readOnly,
          className: 'textarea-input',
          type: type || 'text',
          ref: function ref(c) {
            _this3.ref = c;
          },
          placeholder: '',
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          disabled: disabled,
          value: value,
          autoFocus: autoFocus,
          spellCheck: spellcheck,
          style: {
            flex: 1,
            border: 0,
            padding: '5px 8px',
            height: '100%',
            outline: 0,
            background: 'transparent',
            minHeight: minHeight
          }
        }),
        this.renderPlaceholder(null, null, {
          bottom: 'unset',
          top: 5
        })
      );
    }
  }]);
  return IDTextArea;
}(_BaseComponent3.default);

exports.default = IDTextArea;


IDTextArea.defaultProps = {
  iconCls: '',
  iconType: "edit",
  isClearable: true,
  visibleIcon: true,
  disabled: false,
  iconAlign: 'after',
  placeholder: 'Input...',
  minHeight: 100
};